import { Controller } from "@hotwired/stimulus"
import ClipboardJS from "clipboard"

export default class extends Controller {
  connect() {
    $(this.element).on('shown.bs.modal', this.handleModalShown.bind(this))
  }

  handleModalShown() {
    setTimeout(() => this.initializeClipboard(), 100)
  }

  initializeClipboard() {
    if (this.clipboard) {
      this.clipboard.destroy()
    }

    this.clipboard = new ClipboardJS('.copy-btn', {
      container: this.element
    })

  }

  disconnect() {
    $(this.element).off('shown.bs.modal', this.handleModalShown.bind(this))

    if (this.clipboard) {
      this.clipboard.destroy()
    }
  }
}